import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {
  constructor(private _location: Location, private router: Router) { }

  backClicked() {
    if (this.router.navigated) {
      this.router.navigate(['/'])
    } else {
      this.router.navigate(['/'])
    }

  }
}
